<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-click-outside="closeModal">
                    <div class="modal-body">
                        <v-card class="elevation-0"> 
                            <card-header :title="headerTitle"></card-header>

                            <v-card-text>
                                <slot name="body"></slot>
                            </v-card-text>
                        </v-card>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import CardHeader from '@/components/cards/CardHeader.vue';

    export default {
        name: "card-modal",
        components: {
            CardHeader,
        },
        props: {
            headerTitle: {
                type: String,
                required: false,
                default: "상세보기",
            },
        },
        methods: {
            closeModal: function () {
                this.$emit("close");
            },
        },
    };
</script>

<style lang="scss">
    /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .modal-container {
        min-width: 60vw;
    }
</style>